(function ($) {

  window.initLoanApp = window.initLoanApp || function () {
    var loanLengths = {
      home: [
        '1 - 5 Years',
        '6 - 10 Years',
        '11 - 15 Years',
        '16 - 20 Years',
      ],
      lineOfCredit: ['3 Years'],
      personal: ['1 - 2 Years'],
      vehicle: [
        '1 - 2 Years',
        '3 - 4 Years',
        '5 - 7 Years'
      ]
    };

    var loanPurposes = {
      home: ["Home Improvement", "Home Purchase", "Home Refinance", "Other"],
      lineOfCredit: ["Home Improvement", "Home Purchase", "Home Refinance", "Other"],
      personal: ["Other"],
      vehicle: ["Vehicle"],
      unsecuredLineOfCredit: ["Unsecured Line of Credit"]
    };

    //There are validations that depend on these variable names. So do not change them or you'll need to fix the validations found in LoanApplicationBlockController.cs
    var loanConfig = {
      'Home-Equity-Credit': {
        lengthOptions: null,
        purposeOptions: "text",
        showHMDA: true,
        existingAccountRequired: false
      },
      'Home-Equity-Loan': {
        lengthOptions: loanLengths.home,
        purposeOptions: loanPurposes.home,
        showHMDA: ['Home Improvement', 'Home Purchase', 'Home Refinance', 'Other'],
        existingAccountRequired: false
      },
      'Home-Improvement-Mortgage': {
        lengthOptions: loanLengths.home,
        purposeOptions: loanPurposes.home,
        showHMDA: ['Home Improvement', 'Home Purchase', 'Home Refinance'],
        existingAccountRequired: false
      },
      'Home-Improvement-Non-Mortgage': {
        lengthOptions: loanLengths.home,
        purposeOptions: loanPurposes.home,
        showHMDA: false,
        existingAccountRequired: false
      },
      'UnsecuredLineCreditTrigger': {
        lengthOptions: loanLengths.lineOfCredit,
        purposeOptions: loanPurposes.unsecuredLineOfCredit,
        showHMDA: false,
        existingAccountRequired: true
      },
      'Vehicle': {
        lengthOptions: loanLengths.vehicle,
        purposeOptions: loanPurposes.vehicle,
        showHMDA: false,
        existingAccountRequired: false
      },
      'Personal-Unsecured': {
        lengthOptions: loanLengths.personal,
        purposeOptions: loanPurposes.personal,
        showHMDA: false,
        existingAccountRequired: false
      }
    };

    // Source
    var typeOfLoan = $('.js-type-of-loan');
    var jointCredit = $('.js-joint-credit');
    var loanPurpose = $('.js-loan-purpose');
    var loanPurposeTextInput = $('.js-loan-purpose-text input');
    var loanLength = $('.js-loan-length');

    // Destination
    var homeEquityDisclaimer = $('.js-home-equity-disclaimer');
    var vehicleInsuranceDisclaimer = $('.js-vehicle-insurance-disclaimer');
    var creditType = $('.js-credit-type');
    var jointCreditIntend = $('.js-joint-credit-intend');
    var jointApplicant = $('.js-co-applicant');
    var hmda = $('.js-hmda');
    var jointApplicantHmda = $('.js-co-applicant-hmda');
    var loanPurposeOther = $('.js-loan-purpose-other');
    var existingCredit = $('.js-existing-account');
    var selectedLoanLength = 'unselected';
    var selectedLoanPurpose = 'unselected';
    var selectedState = 'unselected';
    var previousSelectedLoan = null;

    var isRelationshipLineOfCredit = false;
    var originalLoanPurposeOptions = loanPurpose.find('option').clone(true);

    function updateItems() {
      var loanType = typeOfLoan.val();

      // Show disclamers depending on loan type
      homeEquityDisclaimer.toggle(typeOfLoan.val() == 'Home-Equity-Credit');
      vehicleInsuranceDisclaimer.toggle(typeOfLoan.val() == 'Vehicle');

      var isJointCredit = jointCredit.prop('checked');
      jointCreditIntend.toggle(isJointCredit);
      jointApplicant.toggle(isJointCredit);
      jointApplicantHmda.toggle(isJointCredit);

      // Show correct options for loan length and loan purpose
      if (loanType != previousSelectedLoan) { // Only when loan type has changed
        updateLoanLength(loanType);
        updateLoanPurpose(loanType);
      }

      toggleLoanPurposeOther();
      showHMDA(loanType);

      newIsRelationshipLineOfCredit = (loanType && loanConfig[loanType].existingAccountRequired)
      existingCredit.toggle(newIsRelationshipLineOfCredit);

      $('.js-applicant-context').each(function () { updateResidenceItems($(this)); });

      // Show appropriate options for whichever state
      var state = $('.js-state').val();
      var states;
      switch (state) {
        case 'KS': states = window.Fidelity.BranchesKS; break;
        case 'MO': states = window.Fidelity.BranchesMO; break;
        case 'OK': states = window.Fidelity.BranchesOK; break;
        default: states = []; break;
      }

      // Change branches if state has changed
      if (state != selectedState) {
        var branchSelect = $('.js-branch select');
        branchSelect.find('option:gt(0)').remove();
        for (var x = 0; x < states.length; x++) {
          branchSelect.append(
            $('<option />')
              .attr('value', states[x].value)
              .text(states[x].value)
          );
        }

        selectedState = state;
      }

// Hide when nothing selected yet, or individual Personal Unsecured or
      // individual Unsecured Relationship Line of Credit are selected.
      var isIndividualCredit = $('.js-indv-credit').prop('checked');

      // Is this individual credit?
      var shouldHide = isIndividualCredit && (loanType == 'UnsecuredLineCreditTrigger' || loanType == 'Personal-Unsecured');
      // Have selections been made?
      var selectionMade = (isIndividualCredit || isJointCredit) && loanType != null;
      var shouldShow = selectionMade && !shouldHide;
      $('.js-marital-status').toggle(shouldShow);

      previousSelectedLoan = loanType;
    }

    function updateResidenceItems(context) {
      var status = context.find('.js-residence-status input[type=radio]:checked').val();

      context.find('.js-status-rent').toggle(status == 'Rent');
      context.find('.js-status-own').toggle(status == 'Own');
      context.find('.js-status-other').toggle(status == 'Other');

      var yearsAtAddress = context.find('.js-years-at-address input[type=radio]:checked').val();
      context.find('.js-previous-address').toggle(yearsAtAddress == 'Yes');

      var yearsEmployed = context.find('.js-years-employed input[type=radio]:checked').val();
      context.find('.js-previous-employer').toggle(yearsEmployed == 'Yes');

      var listOtherIncome = context.find('.js-list-other-income input[type=radio]:checked').val();
      context.find('.js-other-income').toggle(listOtherIncome == 'Yes');

      var paidChildSupport = context.find('.js-pay-child-support input[type=radio]:checked').val();
      context.find('.js-child-support').toggle(paidChildSupport == 'Yes');

      var loanComaker = context.find('.js-loan-comaker input[type=radio]:checked').val();
      context.find('.js-loan-comaker-whom').toggle(loanComaker == 'Yes');
    }

    function captureSubmit() {
      $('.js-loan-application-form').on('submit', function (e) {
        e.preventDefault();

        var t = $(this),
          context = t.closest('.js-loan-application-context'),
          action = t.attr('action');

        var data = t.serialize();

        t.find('[type=submit]').prop('disabled', true);

        $.ajax({
          url: action,
          data: data,
          method: 'POST',
          dataType: 'html'
        }).success(function (data) {
          context.replaceWith(data);
          $('html, body').animate({ scrollTop: $(".validation-summary-errors:not(:empty):visible").offset().top - 300 }, 500);
        });
      });
    }

    function updateLoanLength(newLoanType) {
      // Set Loan lengths from config object
      if (!newLoanType) { return };
      var loan = loanConfig[newLoanType];
      if (!loan.lengthOptions || !loan.lengthOptions.length) {
        loanLength.hide();
        return
      }
      loanLength.show();

      loanLength.find('option').remove();

      var sel = loanLength.find('select');
      if (loan.lengthOptions.length > 1) {
        sel.append($("<option />").prop("selected", "selected").prop("disabled", "disabled").text("Select length of loan"))
      }
      $.each(loan.lengthOptions, function () {
        sel.append($("<option />").val(this).text(this));
      });
      return;
    }

    function updateLoanPurpose(newLoanType) {
      // Set Loan purposes from config object
      if (!newLoanType) { return; }
      var loan = loanConfig[newLoanType];
      $('.js-loan-purpose-container').hide();
      $('.js-loan-purpose-text').hide();
      if (!loan.purposeOptions || !loan.purposeOptions.length) {
        return;
      }
      if (typeof loan.purposeOptions == "string" && loan.purposeOptions == "text") {
        $('.js-loan-purpose-text').show();
      }
      else {
        $('.js-loan-purpose-container').show();
        loanPurpose.find('option:gt(0)').remove();
        $.each(loan.purposeOptions, function () {
          loanPurpose.append($("<option />").val(this).text(this));
        });
      }
    }

    function toggleLoanPurposeOther() {
      var purpose = loanPurpose.val();
      loanPurposeOther.toggle(purpose == 'Other');
    }

    function showHMDA(newLoanType) {
      var loan = loanConfig[newLoanType];
      var isPurposeTextInput = loan && loan.purposeOptions === "text";
      var purpose = isPurposeTextInput ? loanPurposeTextInput.val() : loanPurpose.val();
      if (!loan || !purpose) { hmda.toggle(false); return };
      // show HMDA info when:
      // * showHMDA is an array containing the purpose val
      //   OR
      // * showHMDA is true and the purpose input is text input with any val 
      hmda.toggle(loan.showHMDA && ((loan.showHMDA.length && loan.showHMDA.indexOf(purpose) >= 0) || (isPurposeTextInput && purpose.length > 0)));
    }


    updateItems();

    typeOfLoan.on('change', updateItems);
    creditType.on('change', updateItems);
    loanPurpose.on('change', updateItems);
    loanPurposeTextInput.on('change', updateItems);
    $('.js-residence-status input[type=radio]').on('change', updateItems);
    $('.js-years-at-address input[type=radio]').on('change', updateItems);
    $('.js-years-employed input[type=radio]').on('change', updateItems);
    $('.js-list-other-income input[type=radio]').on('change', updateItems);
    $('.js-pay-child-support input[type=radio]').on('change', updateItems);
    $('.js-loan-comaker input[type=radio]').on('change', updateItems);
    $('.js-existing-account input[type=radio]').on('change', updateItems);
    $('.js-state').on('change', updateItems);

    captureSubmit();
  }

  $(function () {
    window.initLoanApp();
  });

})(jQuery);